import { signalStore, withState, withMethods, patchState, withProps } from '@ngrx/signals';
import { inject, resource } from '@angular/core';
import { InspectionsService } from './inspections.service';

export const InspectionsStore = signalStore(
  { providedIn: 'root' },
  withState<{ filterValues: object }>({
    filterValues: <object>{},
  }),
  withMethods(store => ({
    setFilterValues(value: object) {
      patchState(store, { filterValues: value });
    },
  })),
  withProps((store, inspectionsService = inject(InspectionsService)) => ({
    resource: resource({
      params: store.filterValues,
      loader: async request => inspectionsService.getInspections(request.params),
    }),
  })),
);
